import BusinessUnitTypes from "./businessUnitTypes";
import { createCustomEnum } from "./customEnum";

const BusinessUnitHierarchyTypes = createCustomEnum({
	// BusinessUnitTypes.Aurora
	InsideSales: {
		value: 1,
		name: "inside_sales",
		displayName: "Inside Sales",
		parent: BusinessUnitTypes.Aurora,
	},
	Legacy: {
		value: 2,
		name: "legacy",
		displayName: "Legacy",
		parent: BusinessUnitTypes.Aurora,
	},
	CrossSellOrRetention: {
		value: 3,
		name: "cross_sell_or_retention",
		displayName: "Cross Sell or Retention",
		parent: BusinessUnitTypes.Aurora,
	},

	// BusinessUnitTypes.OnePayment
	InsideSalesOnePayment: {
		value: 1,
		name: "inside_sales",
		displayName: "Inside Sales",
		parent: BusinessUnitTypes.OnePayment,
	},
	LegacyOnePayment: {
		value: 2,
		name: "legacy",
		displayName: "Legacy",
		parent: BusinessUnitTypes.OnePayment,
	},
	CrossSellOrRetentionOnePayment: {
		value: 3,
		name: "cross_sell_or_retention",
		displayName: "Cross Sell or Retention",
		parent: BusinessUnitTypes.OnePayment,
	},

	// BusinessUnitTypes.VnSystems
	InsideSalesVnSystems: {
		value: 1,
		name: "inside_sales",
		displayName: "Inside Sales",
		parent: BusinessUnitTypes.VnSystems,
	},
	LegacyVnSystems: {
		value: 2,
		name: "legacy",
		displayName: "Legacy",
		parent: BusinessUnitTypes.VnSystems,
	},
	CrossSellOrRetentionVnSystems: {
		value: 3,
		name: "cross_sell_or_retention",
		displayName: "Cross Sell or Retention",
		parent: BusinessUnitTypes.VnSystems,
	},

	// BusinessUnitTypes.BusinessDevelopment
	ISOs: {
		value: 4,
		name: "isos",
		displayName: "ISOs",
		parent: BusinessUnitTypes.BusinessDevelopment,
	},
	ISVs: {
		value: 5,
		name: "isvs",
		displayName: "ISVs",
		parent: BusinessUnitTypes.BusinessDevelopment,
	},
	ThirdPartyProducts: {
		value: 6,
		name: "third_party_products",
		displayName: "Third Party Products",
		parent: BusinessUnitTypes.BusinessDevelopment,
	},
	Associations: {
		value: 7,
		name: "associations",
		displayName: "Associations",
		parent: BusinessUnitTypes.BusinessDevelopment,
	},

	// BusinessUnitTypes.Acquisition
	NailSoft: {
		value: 9,
		name: "nail_soft",
		displayName: "NailSoft",
		parent: BusinessUnitTypes.Acquisition,
	},
});

export default BusinessUnitHierarchyTypes;
